// components
import * as Button from './components/Button';
import * as Controls from './components/Controls';
import * as Form from './components/Form';
import * as Modal from './components/Modal/Simple';
import * as Tooltip from './components/Tooltip/Simple';
import * as Select from './components/Select';

import { Provider as KeyboardController } from './components/Keyboard';

// toolkit
import * as Animation from './components/Animation';
import * as InputSDK from './components/Input';
import * as ModalSDK from './components/Modal';
import * as ModalSDKplugins from './components/Modal/plugins';
import * as ModalSDKslot from './components/Modal/slots';
import * as TooltipSDK from './components/Tooltip';
import * as TooltipSDKslot from './components/Tooltip/slots';
import * as SelectSDKslot from './components/Select/slots';
import { utils as colorUtils } from './components/Select/Color';

// core
import * as Env from './core/Env';
import * as hooks from './core/hooks';
import * as Slot from './core/Slot';
import * as Trace from './core/Trace';

import { withConfig } from './components/utils';

const utils = {
    withConfig,
    colorUtils,
}


export {
    Button,
    Controls,
    Form,
    Modal,
    Tooltip,
    KeyboardController,

    Select,
    Animation,
    InputSDK,
    ModalSDK,
    ModalSDKplugins,
    ModalSDKslot,
    TooltipSDK,
    TooltipSDKslot,
    SelectSDKslot,
    
    Env,
    hooks,
    Slot,
    Trace,

    utils,
}
